import { Spinner } from 'react-bootstrap';

function OverlayLoader({ isLoading }) {
    if (isLoading){
        return <div className="overlay-loader"><Spinner animation="border" role="status"><span className="visually-hidden">Loading...</span></Spinner></div>
    }
    return null
}
export default OverlayLoader;